import React, { useEffect } from 'react';
import { Button, Modal } from 'antd';
import "../css/org_selection_popup.css";
import { getIntFromString } from 'modules/look';
export const SelectOrganisation = (props) => {
  const {
    visible,
    onClose,
    selectedAMOrg,
    setSelectedAMOrg,
    navigateRoute,
    me,
    setDefaultOrganization,
    updateDefaultOrganization
  } = props;
  const [selectedOrg, setSelectedOrg] = React.useState(selectedAMOrg);
  const [updatedOrgId, setUpdatedOrgId] = React.useState(null);
  useEffect(() => {
    if (selectedAMOrg) {
      setSelectedOrg(selectedAMOrg);
    }
  }, [selectedAMOrg])

  const handleOrgSelection = async () => {
    let response = null;
    if (me?.employee?.defaultOrganization || updatedOrgId) {
      response = await updateDefaultOrganization({ id: me?.employee?.defaultOrganization?.id || updatedOrgId, defaultOrganizationId: getIntFromString(selectedOrg?.id) })
    } else {
      response = await setDefaultOrganization({ employeeId: me?.employee?.id, defaultOrganizationId: selectedOrg?.id })
    }
    if (response) {
      localStorage.removeItem("selectedAMOrg");
      localStorage.removeItem("orgDataToSend");
      localStorage.setItem("selectedAMOrg", JSON.stringify(selectedOrg))
      localStorage.setItem("orgDataToSend", JSON.stringify(selectedOrg))
      setUpdatedOrgId(response); // Adding because me query is not updating on the fly
      setSelectedAMOrg(selectedOrg);
    }
    onClose(true);
  }

  const handleCancel = () => {
    if (!selectedAMOrg)
      navigateRoute(-1);
    setSelectedOrg(selectedAMOrg);
    onClose(false);
  }
  return (
    <Modal
      title="Select Organisation"
      className='org-selection-popup'
      visible={visible}
      onCancel={handleCancel}
      centered
      width={350}
      destroyOnClose
      closable={false}
      footer={[
        <Button className='org-popup-button' key="cancel" type="primary" onClick={handleCancel}>
          Cancel
        </Button>,
        <Button className='org-popup-button' key="save" type="primary" onClick={handleOrgSelection} disabled={!selectedOrg}>
          Save
        </Button>,
      ]}
    >
      <div className="select-organisation">
        <div className="select-organisation-list">
          {
            me?.employee?.orgAmEmployee?.edges?.map((org, index) => (
              <div
                key={index}
                className={`organisation-item ${selectedOrg?.id === org.node.id ? 'selected' : ''}`}
                onClick={() => setSelectedOrg(org?.node)}
              >
                {org?.node?.name}
              </div>
            ))
          }
        </div>
      </div>
    </Modal>
  )
}